var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      !_vm.isSearching
        ? _c(
            "div",
            {
              staticClass: "studip-tree",
              class: {
                "studip-tree-navigatable": _vm.showStructureAsNavigation,
              },
            },
            [
              _vm.isLoading
                ? _c("studip-progress-indicator", {
                    attrs: {
                      size: 48,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.viewType === "list" && _vm.startNode
                ? _c("studip-tree-list", {
                    attrs: {
                      "with-children": _vm.withChildren,
                      "visible-children-only": _vm.visibleChildrenOnly,
                      "with-courses": _vm.withCourses,
                      semester: _vm.semester,
                      "sem-class": _vm.semClass,
                      node: _vm.startNode,
                      "breadcrumb-icon": _vm.breadcrumbIcon,
                      editable: _vm.editable,
                      "edit-url": _vm.editUrl,
                      "create-url": _vm.createUrl,
                      "delete-url": _vm.deleteUrl,
                      "with-export": _vm.withExport,
                      "show-structure-as-navigation":
                        _vm.showStructureAsNavigation,
                      assignable: _vm.assignable,
                      "with-course-assign": _vm.withCourseAssign,
                    },
                    on: {
                      "change-current-node": _vm.changeCurrentNode,
                    },
                  })
                : _vm.viewType === "table" && _vm.startNode
                ? _c("studip-tree-table", {
                    attrs: {
                      "with-children": _vm.withChildren,
                      "visible-children-only": _vm.visibleChildrenOnly,
                      "with-courses": _vm.withCourses,
                      semester: _vm.semester,
                      "sem-class": _vm.semClass,
                      node: _vm.startNode,
                      "breadcrumb-icon": _vm.breadcrumbIcon,
                      editable: _vm.editable,
                      "edit-url": _vm.editUrl,
                      "create-url": _vm.createUrl,
                      "delete-url": _vm.deleteUrl,
                      "with-export": _vm.withExport,
                      "show-structure-as-navigation":
                        _vm.showStructureAsNavigation,
                      assignable: _vm.assignable,
                      "with-course-assign": _vm.withCourseAssign,
                    },
                    on: {
                      "change-current-node": _vm.changeCurrentNode,
                    },
                  })
                : _vm.viewType === "tree" && _vm.startNode
                ? _c("studip-tree-node", {
                    attrs: {
                      "with-info": _vm.withInfo,
                      "visible-children-only": _vm.visibleChildrenOnly,
                      node: _vm.startNode,
                      "open-levels": _vm.openLevels,
                      openNodes: _vm.openNodes,
                      "breadcrumb-icon": _vm.breadcrumbIcon,
                      editable: _vm.editable,
                      "edit-url": _vm.editUrl,
                      "create-url": _vm.createUrl,
                      "delete-url": _vm.deleteUrl,
                      assignable: _vm.assignable,
                      "assign-leaves-only": _vm.assignLeavesOnly,
                      "not-assignable-nodes": _vm.notAssignableNodes,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "studip-tree",
            },
            [
              _c("tree-search-result", {
                attrs: {
                  "search-config": _vm.searchConfig,
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _vm.withSearch
        ? _c(
            "MountingPortal",
            {
              attrs: {
                mountTo: "#search-widget",
                name: "sidebar-search",
              },
            },
            [
              _vm.currentNode
                ? _c("search-widget", {
                    ref: "searchWidget",
                    attrs: {
                      "min-length": 3,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.editable && !_vm.isSearching && !_vm.isLoading && _vm.currentNode
        ? _c(
            "MountingPortal",
            {
              attrs: {
                mountTo: "#views-widget",
                name: "sidebar-views",
              },
            },
            [
              _c("studip-tree-view-widget", {
                attrs: {
                  config: _vm.viewConfig,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }